module.exports = __webpack_public_path__ + "img/9791130626970.81aade48.jpg";